import { SituationObject } from '@yes.technology/react-toolkit'

const mockSituations: SituationObject[] = [
  {
    code: '40',
    complement: '',
    date_creation_row: '2021-11-09T18:18:30Z',
    date_end_estimated_row: '',
    date_end_row: '',
    date_modification_row: '2022-01-31T14:50:57Z',
    date_start_estimated_row: '',
    date_start_row: '',
    des: 'Active',
    obs: '',
    situation: '40',
    uuid: '277e25a0-86d2-4405-8a0d-c9d744a1e361',
    uuid_Objectclass: 'UUID_Objectclass_Situation',
    uuid_language: 'pt-BR',
    uuid_status: '',
    uuid_user_creation_row: '',
    uuid_user_modification_row: 'd1729d93-60c8-11eb-998f-0e8c17226e8a',
    version: '3'
  },
  {
    code: '0',
    complement: '',
    date_creation_row: '2021-11-09T18:11:56Z',
    date_end_estimated_row: '',
    date_end_row: '',
    date_modification_row: '2021-11-09T18:11:56Z',
    date_start_estimated_row: '',
    date_start_row: '',
    des: 'Discarded',
    obs: '',
    situation: '40',
    uuid: '51670270-e227-40ce-8538-b8f6c629d333',
    uuid_Objectclass: 'UUID_Objectclass_Situation',
    uuid_language: 'pt-BR',
    uuid_status: '',
    uuid_user_creation_row: '',
    uuid_user_modification_row: '',
    version: '1'
  },
  {
    code: '11',
    complement: '',
    date_creation_row: '2021-12-06T17:04:13Z',
    date_end_estimated_row: '',
    date_end_row: '',
    date_modification_row: '2021-12-06T19:31:24Z',
    date_start_estimated_row: '',
    date_start_row: '',
    des: 'In insertion - activation requestable',
    obs: '',
    situation: '40',
    uuid: '6d91a3b4-1c4c-48f0-bde1-cddb6a7af68d',
    uuid_Objectclass: 'UUID_OBJECTCLASS_SITUATION',
    uuid_language: '',
    uuid_status: '',
    uuid_user_creation_row: '',
    uuid_user_modification_row: '8d8e58b6-25a7-11ea-998f-0e8c17226e8a',
    version: '2'
  },
  {
    code: '20',
    complement: '',
    date_creation_row: '2021-11-09T18:22:12Z',
    date_end_estimated_row: '',
    date_end_row: '',
    date_modification_row: '2021-11-09T18:22:12Z',
    date_start_estimated_row: '',
    date_start_row: '',
    des: 'Blocked',
    obs: '',
    situation: '40',
    uuid: '791d3536-5d98-4aaa-8e34-d3b0c49f3f03',
    uuid_Objectclass: 'UUID_Objectclass_Situation',
    uuid_language: 'pt-BR',
    uuid_status: '',
    uuid_user_creation_row: '',
    uuid_user_modification_row: '',
    version: '1'
  },
  {
    code: '30',
    complement: '',
    date_creation_row: '2021-11-09T18:26:37Z',
    date_end_estimated_row: '',
    date_end_row: '',
    date_modification_row: '2021-11-09T18:26:37Z',
    date_start_estimated_row: '',
    date_start_row: '',
    des: 'Archived',
    obs: '',
    situation: '40',
    uuid: '9e6811f7-1aee-423f-b4ca-72938bbc7f0b',
    uuid_Objectclass: 'UUID_Objectclass_Situation',
    uuid_language: 'pt-BR',
    uuid_status: '',
    uuid_user_creation_row: '',
    uuid_user_modification_row: '',
    version: '1'
  },
  {
    code: '5',
    complement: '',
    date_creation_row: '2021-11-09T18:21:37Z',
    date_end_estimated_row: '',
    date_end_row: '',
    date_modification_row: '2021-11-09T18:21:37Z',
    date_start_estimated_row: '',
    date_start_row: '',
    des: 'Deleted',
    obs: '',
    situation: '40',
    uuid: 'a671b940-50e4-451a-843d-789111050e29',
    uuid_Objectclass: 'UUID_Objectclass_Situation',
    uuid_language: 'pt-BR',
    uuid_status: '',
    uuid_user_creation_row: '',
    uuid_user_modification_row: '',
    version: '1'
  },
  {
    code: '10',
    complement: '',
    date_creation_row: '2021-12-06T17:03:14Z',
    date_end_estimated_row: '',
    date_end_row: '',
    date_modification_row: '2021-12-07T01:30:46Z',
    date_start_estimated_row: '',
    date_start_row: '',
    des: 'In insertion - required fields missing',
    obs: '',
    situation: '40',
    uuid: 'cfc32eab-7e8f-459b-948f-71df993ab74a',
    uuid_Objectclass: 'UUID_OBJECTCLASS_SITUATION',
    uuid_language: '',
    uuid_status: '',
    uuid_user_creation_row: '',
    uuid_user_modification_row: '8d8e58b6-25a7-11ea-998f-0e8c17226e8a',
    version: '2'
  }
]

export default mockSituations
